

    export class GrupoPermissao
    {
        constructor() {
          this.Id = 0;
          this.Nome = "";
          this.Descricao = "";
          this.DataCriacao = "1990-01-02T00:00:01";;
          this.Usuario = "";
        }
        public Id: number;
        public Nome: string;
        public Descricao: string;
        public DataCriacao: string;
        public Usuario: string;
        public ListaPermissaoPagina: any      ;
        public ListaPermissaoRelatorio:any      ;
    }




    export class PermissaoRelatorio
    {
        constructor() {
          this.Id = 0;
          this.IdMenuDinamico = 0;
          this.nameMenuDinamico = "";
          this.IdModulo = 0;
          this.NomeModulo = "";
          this.IdModuloRelatorio = 0;
          this.DescricaoModuloRelatorio = "";
          this.Ativo = false;

        }

        public Id: number     ;
        public IdMenuDinamico:   number   ;
        public nameMenuDinamico:   string   ;
        public IdModulo:   number   ;
        public NomeModulo:string      ;
        public IdModuloRelatorio:number;
        public DescricaoModuloRelatorio:string      ;
        public Ativo: boolean     ;
    }

    export class PermissaoPagina
    {
        constructor() {
          this.Id = 0;
          this.Pagina = new Pagina();
          this.Ativo = false;
        }

        public Id: number     ;
        public Pagina: Pagina ;
        public Ativo: boolean     ;

    }

    export class Pagina
    {
        constructor() {
          this.Id = 0;
          this.Descricao = "";
        }

        public Id: number     ;
        public Descricao:string      ;

    }




